import React, { useContext, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Button, Link, Typography } from '@mui/material';

import { Link as RouterLink } from 'react-router-dom';
import { AppContext } from '@/AppContext';

const PREFIX = 'SettingsToolbar';

const classes = {
  root: `${PREFIX}-root`,
  row: `${PREFIX}-row`,
  spacer: `${PREFIX}-spacer`,
  link: `${PREFIX}-link`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },

  [`& .${classes.row}`]: {
    display: 'flex',
  },

  [`& .${classes.spacer}`]: {
    flexGrow: 1,
  },

  [`& .${classes.link}`]: {
    marginTop: '8px',
  },
}));

const SettingsToolbar = props => {
  const { className, meetupId, ...rest } = props;

  return (
    <Root {...rest} className={clsx(classes.root, className)}>
      <div className={classes.row}>
        <span className={classes.spacer} />
        <RouterLink to={'/m/' + meetupId + '/settings/field/add'}>
          <Button color='primary' variant='contained'>
            Добавить поле
          </Button>
        </RouterLink>
      </div>
    </Root>
  );
};

SettingsToolbar.propTypes = {
  className: PropTypes.string,
};

export default SettingsToolbar;
